/** Shared button. Replaces the hardcoded bg-blue-900/600/700 variants, which
 *  rendered as off-brand navy blocks on the dark theme. */
import React from "react";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md";

const VARIANTS: Record<Variant, string> = {
  primary: "bg-accent text-accent-fg hover:bg-accent-hover border-transparent font-semibold",
  secondary:
    "bg-surface-raised text-content hover:bg-surface-hover border-edge-strong",
  ghost: "bg-transparent text-content-muted hover:bg-surface-hover hover:text-content border-transparent",
  danger: "bg-danger text-content-inverse hover:opacity-90 border-transparent font-semibold",
};

const SIZES: Record<Size, string> = {
  sm: "px-2.5 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

export default function Button({
  variant = "secondary",
  size = "md",
  className = "",
  type = "button",
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 rounded-lg border transition-colors duration-100 disabled:cursor-not-allowed disabled:opacity-50 ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...rest}
    />
  );
}
